import React from 'react';
import { Link } from 'react-router-dom'; // If you're using React Router

// Basic Error Page Layout Component
const ErrorPageLayout = ({ statusCode, title, message }) => {
  return (
    <div style={styles.container}>
      <h1 style={styles.statusCode}>{statusCode}</h1>
      <h2 style={styles.title}>{title}</h2>
      <p style={styles.message}>{message}</p>
      {/* Conditionally render a "Go Home" button if using React Router */}
      {Link && (
        <Link to="/" style={styles.homeLink}>
          Go back to the homepage
        </Link>
      )}
    </div>
  );
};

// Styles for the error pages
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    fontFamily: 'sans-serif',
    padding: '20px',
  },
  statusCode: {
    fontSize: '4em',
    fontWeight: 'bold',
    color: '#dc3545', // Error color
    marginBottom: '10px',
  },
  title: {
    fontSize: '2em',
    marginBottom: '15px',
  },
  message: {
    fontSize: '1.2em',
    color: '#6c757d', // Secondary text color
    marginBottom: '20px',
  },
  homeLink: {
    textDecoration: 'none',
    color: '#007bff', // Primary link color
    fontWeight: 'bold',
    padding: '10px 20px',
    border: '1px solid #007bff',
    borderRadius: '5px',
    transition: 'background-color 0.3s ease',
  },
  homeLinkHover: {
    backgroundColor: '#007bff',
    color: '#fff',
  },
};

// 404 Not Found Page
const NotFoundPage = () => {
  return (
    <ErrorPageLayout
      statusCode="404"
      title="Page Not Found"
      message="The page you are looking for does not exist."
    />
  );
};

// 500 Internal Server Error Page
const InternalServerErrorPage = () => {
  return (
    <ErrorPageLayout
      statusCode="500"
      title="Internal Server Error"
      message="Oops! Something went wrong on our server."
    />
  );
};

// 403 Forbidden Page
const ForbiddenPage = () => {
  return (
    <ErrorPageLayout
      statusCode="403"
      title="Forbidden"
      message="You do not have permission to access this resource."
    />
  );
};

// 401 Unauthorized Page
const UnauthorizedPage = () => {
  return (
    <ErrorPageLayout
      statusCode="401"
      title="Unauthorized"
      message="You need to be logged in to access this page."
    />
  );
};

// You can add more error pages as needed (e.g., 400 Bad Request)

// Example of how to use these pages with React Router (in your App.js or similar)
/*
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="/500" element={<InternalServerErrorPage />} />
        <Route path="/403" element={<ForbiddenPage />} />
        <Route path="/401" element={<UnauthorizedPage />} />
        {/* Your other routes * /}
        {/* Catch-all route for 404 * /}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
*/

export { NotFoundPage, InternalServerErrorPage, ForbiddenPage, UnauthorizedPage };